let queryString = function(payload) {
    let query = "";
    if (payload) {
        let keys = Object.keys(payload);
        keys.forEach((each, index) => {
            let key = each;
            let value = payload[each] === null || payload[each] === undefined ? "" : payload[each];
            query += `${key}=${value}`;
            if(index != keys.length - 1) query += "&";
        });
    }
    return query;
}


export default queryString;